/**
 * Removes elements from the parentArray that are found in the childArray, based on a shared identifier.
 *
 * This function compares elements of parentArray and childArray based on the value of a specified
 * identifier property. If an element in parentArray has an identifier value that matches any identifier
 * value in childArray, it is excluded from the resulting array. The function essentially performs a
 * set difference operation, where the elements in childArray are subtracted from parentArray.
 *
 * @param {Array} parentArray - The array from which elements will be removed.
 * @param {Array} childArray - The array containing elements that, if found in parentArray, will be removed.
 * @param {string} identifier - The property name used to compare elements between arrays.
 *
 * @returns {Array} A new array consisting of elements from parentArray that are not present in childArray.
 *
 * Usage Example:
 *   const parent = [{ id: 1, name: 'Apple' }, { id: 2, name: 'Banana' }, { id: 3, name: 'Cherry' }];
 *   const children = [{ id: 2, name: 'Banana' }, { id: 4, name: 'Date' }];
 *   const result = removeFromArray(parent, children, 'id');
 *   // result will be [{ id: 1, name: 'Apple' }, { id: 3, name: 'Cherry' }]
 */
export const removeFromArray = (parentArray, childArray, identifier) => {
  const childIds = new Set(childArray.map((child) => child[identifier]));
  return parentArray.filter((parent) => !childIds.has(parent[identifier]));
};
